import feesChargesContent from "./content/fees-and-charges.json";

export const feesChargesMock = {
  name: "fees-and-charges",
  layoutType: 1,
  areasList: [
    {
      id: "fees-and-charges-1",
      name: "fees-and-charges-content",
      componentName: "Comp:FeesChargesPage",
      content: JSON.stringify(feesChargesContent),
    },
  ],
};
